import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Dots = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "2.5" }),
    React.createElement("circle", { cx: "4", cy: "12", r: "2.5" }),
    React.createElement("circle", { cx: "20", cy: "12", r: "2.5" })), 'Dots');
export default Dots;
